import axios from "axios";
import {
  refreshToken,
  handleTokenRefreshFailure,
} from "../components/auth/tokenRefreshService";
import { isTokenExpired } from "./helpers";

const axiosInstance = axios.create({});

const parseErrors = (err) => {
  if (err.response) {
    throw err.response.data;
  } else if (err.request) {
    console.log("network error");
  } else {
    console.log("something unique happened");
  }
};

const createHeaders = async (additionalHeaders = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...additionalHeaders,
  };

  let token = localStorage.getItem("token");

  if (token && isTokenExpired(token)) {
    const newToken = await refreshToken();
    if (newToken) {
      token = newToken;
    } else {
      handleTokenRefreshFailure();
      return headers;
    }
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const makeRequest = async (
  method,
  url,
  data = {},
  additionalHeaders = {},
  isRetry = false,
) => {
  const headers = await createHeaders(additionalHeaders);

  try {
    if (headers.Authorization) {
      const res = await axiosInstance({
        method,
        url,
        data,
        headers,
      });
      return res.data;
    }
    return null;
  } catch (err) {
    if (err.response?.status === 401 && !isRetry) {
      const newToken = await refreshToken();
      if (newToken) {
        return await makeRequest(method, url, data, additionalHeaders, true);
      }
      handleTokenRefreshFailure();
      return;
    }

    if (err.response?.data && err.response.status === 400) {
      const errorData = err.response.data;
      if (errorData.error) {
        err.message = errorData.error;
      }
    }
    parseErrors(err);
  }
};

export default makeRequest;
